import { useState } from 'react';
import { faqs } from '@/mocks/gossip';
import SectionHeading from './SectionHeading';

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" className="scroll-mt-20 py-12 md:py-16">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-8 px-4 md:px-6 lg:grid-cols-[0.9fr_1.4fr]">
        <div className="lg:sticky lg:top-24 lg:self-start">
          <SectionHeading
            eyebrow="常见问题"
            title="关于吃瓜大全，你关心的都在这里"
            desc="从更新频率到信息可信度，我们整理了大家最常问的几个问题，如果还有疑问，欢迎随时联系我们。"
            accentIcon="ri-question-line"
          />
          <div className="mt-6 inline-flex items-center gap-3 rounded-2xl border border-background-200 bg-background-100/60 px-5 py-4">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-100 text-lg text-primary-600">
              <i className="ri-customer-service-2-line" />
            </span>
            <div>
              <p className="text-sm font-semibold text-foreground-900">还是没找到答案？</p>
              <p className="text-xs text-foreground-500">直接找我们聊聊，随时为你解答</p>
            </div>
          </div>
        </div>

        <div className="space-y-3">
          {faqs.map((f, i) => {
            const open = openIdx === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-2xl border transition-colors ${
                  open ? 'border-primary-200 bg-primary-50/50' : 'border-background-200 bg-background-100/50'
                }`}
              >
                <button
                  onClick={() => setOpenIdx(open ? -1 : i)}
                  className="flex w-full items-center gap-3 px-5 py-4 text-left"
                >
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-base font-bold transition-colors ${
                      open ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-500'
                    }`}
                  >
                    Q
                  </span>
                  <span className="flex-1 font-heading text-base font-bold text-foreground-950 md:text-lg">
                    {f.q}
                  </span>
                  <i
                    className={`text-xl text-foreground-500 transition-transform duration-300 ${
                      open ? 'rotate-45 text-primary-600' : ''
                    } ri-add-line`}
                  />
                </button>
                {open && (
                  <div className="flex gap-3 px-5 pb-5 pl-[3.25rem]">
                    <p className="text-sm leading-relaxed text-foreground-600">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}